import { FooterPayments } from './FooterPayments';
import OptimizedImage from './OptimizedImage';
export function FooterTrust({ locale }) {
  const english = locale === 'en';
  return <div className="footer-trust" data-footer-trust="">
    <section className="footer-trust-group" aria-labelledby={`footer-security-${locale}`}>
      <h2 className="footer-trust-title" id={`footer-security-${locale}`}>{english ? 'Security & compliance' : 'Güvenlik ve uyum'}</h2>
      <div className="footer-trust-badges">
        <div className="footer-trust-label" aria-label={english ? 'GDPR Compliant' : 'GDPR uyumlu'}>
          <svg width="28" height="32" viewBox="0 0 28 32" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" aria-hidden="true"><path d="M14 2c4 3 8 4 11 5v10c0 6-5 10-11 13C8 27 3 23 3 17V7c3-1 7-2 11-5Z"/></svg>
          <span><strong>GDPR</strong><small>{english ? 'Compliant' : 'Uyumlu'}</small></span>
        </div>
        <div className="footer-trust-label" aria-label="ISO/IEC 27001">
          <svg width="28" height="32" viewBox="0 0 28 32" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="4" y="14" width="20" height="16" rx="2"/><path d="M8 14V8a6 6 0 0 1 12 0v6M14 21v4"/><circle cx="14" cy="20" r="1"/></svg>
          <span><strong>ISO/IEC</strong><small>27001</small></span>
        </div>
      </div>
    </section>
    <section className="footer-trust-group footer-trust-partners" aria-labelledby={`footer-partners-${locale}`}>
      <h2 className="footer-trust-title" id={`footer-partners-${locale}`}>{english ? 'Technology partnerships' : 'Teknoloji iş ortaklıkları'}</h2>
      <div className="footer-trust-badges">
        <OptimizedImage className="footer-trust-meta" src="/assets/trust/meta-business-partner.png" alt={english ? 'Meta Business Partner' : 'Meta iş ortağı'} width="774" height="444" loading="lazy" decoding="async"/>
        <svg className="footer-trust-aws" width="80" height="80" viewBox="135.4 60.7 329.4 329.4" role="img" aria-label={english ? 'AWS Partner' : 'AWS iş ortağı'}>
          <title>{english ? 'AWS Partner' : 'AWS iş ortağı'}</title>
          {/* Frame the artwork without the source file's transparent canvas margins. */}
          <image href="/assets/trust/aws-partner.svg" width="600" height="450"/>
        </svg>
      </div>
    </section>
    <section className="footer-trust-group footer-trust-payments" aria-labelledby={`footer-payments-${locale}`}>
      <h2 className="footer-trust-title" id={`footer-payments-${locale}`}>{english ? 'Payment methods' : 'Ödeme yöntemleri'}</h2>
      <div className="footer-trust-badges"><FooterPayments /></div>
    </section>
  </div>;
}
